import { Component } from '@angular/core';
import { AlertController, ModalController, NavParams } from 'ionic-angular';


import { MenuService } from '../../providers/menu-service';
import { AlertService } from '../../providers/alert-service';

import { DadosgeraisService } from '../../providers/dadosgerais-service';
import { UsuarioService } from '../../providers/usuario-service';
import { GestaoPcaService } from '../../providers/gestao-pca-service';
import { ModulosController } from '../modulos/modulos-controller';

import { ModalArquivosPage } from '../modais/modal-arquivos/modal-arquivos';

declare var jsPDF: any;

/*
  Generated class for the DadosGerais page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-dados-gerais',
  templateUrl: 'dados-gerais.html',
  providers: [
    DadosgeraisService
  ]
})
export class DadosGeraisPage extends ModulosController{

  // Lista Construtora da Página
  dadosgerais: any;
  PCAAtiva: any;
  usuario: any;
  isJurisdicionado: boolean;
  isCGE: boolean;

  idModuloPca: any = null;
  idModuloAnalise: any = null;
  idProcesso: any = null;
  tipoAnalise: any = null;
  cdModulo: any = null;
  listaAnalises: any = [];
  loading: boolean = true;
  analise: any = null;

  //Construtor da Página
  constructor(public alertCtrl: AlertController,
    private dadosgeraisService: DadosgeraisService,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public gestaoPcaService: GestaoPcaService,
    public usuarioService: UsuarioService,
    public menuService: MenuService,
    public alertService: AlertService) {
      super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);

    this.carregaDadosGerais();

    this.setModuloId(15);
    this.usuario = this.usuarioService.obtemUsuario();
    this.isJurisdicionado = this.usuarioService.isJurisdicionado();
    this.isCGE = this.usuarioService.isCGE();

    usuarioService.getUsuario().subscribe(broadcastVariable => {
      this.usuario = broadcastVariable.usr;
      if (this.usuario.tipo == 1) {
        this.isJurisdicionado = true;
      } else {
        this.isJurisdicionado = false;
      }
    });

    // entra neste if quando a origem é qualquer modulo do sistema.
    if (this.navParams.get('analise') != undefined) {

      this.analise = this.navParams.get('analise');
      this.idModuloPca = this.navParams.get('analise').idModuloPca;
      this.idModuloAnalise = this.navParams.get('analise').idModuloAnalise;

      if (this.navParams.get('analise').idProcesso != undefined) {
        this.idProcesso = this.navParams.get('analise').idProcesso; // Codigo do ID Processo enviado dos módulos
        this.tipoAnalise = this.navParams.get('analise').cdAnalise;
        this.cdModulo = this.navParams.get('analise').cdModulo;
      } else {
        this.idProcesso = 0;
        this.tipoAnalise = 0;
      }

    } else {
      this.idModuloAnalise = -1;
      this.idModuloPca = -1;
      this.idProcesso = 0;
      this.tipoAnalise = 0;
    }

  }

  carregaDadosGerais() {

    this.PCAAtiva = this.gestaoPcaService.getPCA();

    this.dadosgeraisService.obterDadosGerais(this.PCAAtiva.id).subscribe(data => {
      this.dadosgerais = data;
      this.dadosgerais.nmOrgao = this.PCAAtiva.dsJurisdicionado;
    }, error => {
      console.log("erro: " + error);
      this.mostrarAlerta("", "Houve um erro no carregamento dos Dados Gerais.");
    });

    // this.dadosgeraisService.obterAnalisesDadosGerais(this.PCAAtiva.id).subscribe(data => {
    //   this.listaAnalises = data;
    //   this.loading = false;
    // }, error => {
    //   console.log("erro: " + error);
    //   this.loading = false;
    // });
  }

  editarDadosGerais() {
    this.dadosgeraisService.salvarDadosGerais(this.dadosgerais, this.PCAAtiva.id).subscribe(data => {
      this.dadosgerais = data;
      this.carregaDadosGerais();
      this.mostrarAlerta("", "Dados Gerais editados com sucesso.");
    }, error => {
      console.log(error);
      // this.mostrarAlerta("", "Houve um erro na edição dos Dados Gerais.");
      this.mostrarAlerta('', error.mensagem);
    });
  }

  abrirEstruturaOrganizacional(item) {
    let titulo = "Documentos";

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: 0,
        idModuloPCA: this.idModuloPca,
        tipoAnalise: '20',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemFilter: 'DADOS GERAIS',
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
      this.carregaDadosGerais();
    });

    modal.present();

  }

  abrirLegislacao(item) {
    let titulo = "Documentos";

    let modal = this.modalCtrl.create(ModalArquivosPage,
      {
        titulo: titulo,
        IdProcesso: 0,
        idModuloPCA: this.idModuloPca,
        tipoAnalise: '21',
        jurisdicionado: this.isJurisdicionado,
        isCGE: this.isCGE,
        origemFilter: 'DADOS GERAIS',
        tipoEntidadeExercicio: 0,
        tipodocumento: 0,
        analise: this.analise
      });
    modal.onDidDismiss(retornoModal => {
       this.carregaDadosGerais();
    });

    modal.present();
  }

  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Confirmar']
    });
    alert.present();
  }

  voltarPCA() {
    let idSecaoPaginaGestaoPCA = '964';

    this.menuService.redirecionarPagina(idSecaoPaginaGestaoPCA);
  }

  printData() {

    var doc = new jsPDF("l");
    var totalPagesExp = "{total_pages_count_string}";

    var pageContent = function (data) {
      // HEADER
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.setFontStyle('normal');

      doc.text("Dados Gerais", data.settings.margin.left + 15, 22);

      // FOOTER
      var str = "Page " + data.pageCount;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    };

    var columns = [
      { title: "Nome do Órgão", dataKey: "nome" },
      { title: "Descrição Geral", dataKey: "desc" },
      { title: "Missão", dataKey: "missao" },
      { title: "Visão", dataKey: "visao" },
      { title: "Finalidade", dataKey: "finalidade" },
      { title: "Competências", dataKey: "compet" },
      { title: "Estrutura Org. Enviada?", dataKey: "estrutura" },
      { title: "Legislação Básica Enviada?", dataKey: "legislacao" }
    ];

    let rows = [];

    let estrutura;
    let legislacao;

    if (this.dadosgerais.estruturaArquivo.length == 0) {
      estrutura = "Não";
    } else {
      estrutura = "Sim";
    }

    if (this.dadosgerais.legislacaoArquivo.length == 0) {
      legislacao = "Não";
    } else {
      legislacao = "Sim";
    }



    var item = {
      "nome": this.dadosgerais.nmOrgao,
      "desc": this.dadosgerais.dsGeral,
      "missao": this.dadosgerais.dsMissao,
      "visao": this.dadosgerais.dsVisao,
      "finalidade": this.dadosgerais.dsFinalidade,
      "compet": this.dadosgerais.dsCompetencias,
      "estrutura": estrutura,
      "legislacao": legislacao
    };

    rows.push(item);

    doc.autoTable(columns, rows, {
      //   theme: 'grid',
      //   addPageContent: pageContent,
      //   margin: { top: 30 }
      // });

      theme: 'grid',
      addPageContent: pageContent,
      margin: {
        top: 30,
        left: 5
      },
      styles: {
        overflow: 'linebreak',
        columnWidth: 'wrap',
        fontSize: 8
      },
      // columnStyles: {
      //   text: { columnWidth: 'auto' }
      // },
      columnStyles: {
        text: { columnWidth: 'wrap' },
        nome: {
          columnWidth: 25,
        },
        desc: {
          columnWidth: 45
        },
        missao: {
          columnWidth: 32
        },
        visao: {
          columnWidth: 45
        },
        finalidade: {
          columnWidth: 45
        },
        compet: {
          columnWidth: 45
        },
        estrutura: {
          columnWidth: 20
        },
        legislacao: {
          columnWidth: 20
        }
      }
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp);
    }

    doc.save('dados_gerais.pdf');
  }

}



// WEBPACK FOOTER //
// ./src/pages/dados-gerais/dados-gerais.ts